import { PRICING } from '../../config/pricingConfig';

interface CreditPackSectionProps {
  onBuyCredits: () => void;
  isLoading: boolean;
}

export const CreditPackSection = ({
  onBuyCredits,
  isLoading,
}: CreditPackSectionProps) => (
  <div
    className={`
      mt-6 w-full max-w-6xl rounded-[30px] bg-[rgba(92,107,255,0.2)] p-6
      sm:mt-8
    `}
  >
    <div
      className={`
        flex flex-col items-center gap-4 text-center
        md:flex-row md:justify-between md:text-left
      `}
    >
      <div>
        <h3 className="text-base font-light text-[#0d0d0d]">Credit Pack</h3>
        <ul className="mt-2 list-inside list-disc text-sm text-[#333]">
          <li>One-time purchase. Never expires.</li>
          <li>Perfect for occasional users</li>
          <li>Great when you need more than monthly credits</li>
        </ul>
      </div>
      <div className="flex flex-col items-center gap-3 md:flex-row md:gap-6">
        <div className="text-center md:text-right">
          <span className="text-[32px] font-light text-[#0d0d0d]">
            ${PRICING.creditPack.price.toFixed(2)}
          </span>
          <span className="ml-2 text-base text-[#0d0d0d]">
            / {PRICING.creditPack.credits} credits
          </span>
        </div>
        <button
          onClick={onBuyCredits}
          disabled={isLoading}
          className={`
            cursor-pointer rounded-full border border-black bg-white px-6 py-2.5
            text-[15px] text-[#333] transition-all duration-100
            hover:bg-gray-100
            active:scale-95
            disabled:cursor-not-allowed disabled:opacity-50
          `}
        >
          {isLoading ? 'Loading...' : 'Get a pack'}
        </button>
      </div>
    </div>
  </div>
);
